import { Node, mergeAttributes } from "@tiptap/core";

// Placeholder je atom, ne goli tekst {{...}}. Goli tekst se može djelimično
// obrisati ({{terapeut.im}}) i tiho pukne tek pri generisanju PDF-a; atom je
// nedjeljiv i PDF renderer samo pročita attrs.key.
export const PlaceholderToken = Node.create({
  name: "placeholder",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      key: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-placeholder-key") ?? "",
        renderHTML: (attributes) => ({ "data-placeholder-key": attributes.key }),
      },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-placeholder-key]" }];
  },

  renderHTML({ HTMLAttributes, node }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, { class: "doc-placeholder" }),
      `{${node.attrs.key}}`,
    ];
  },

  renderText({ node }) {
    return `{${node.attrs.key}}`;
  },
});
